/**
 * ReportMetrics - Componente de métricas do relatório
 *
 * Exibe cards com métricas resumidas do período selecionado
 */
import React from "react";
import { Card, CardContent } from "../../../components/ui/card";
import Icon from "../../../components/AppIcon";

const ReportMetrics = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const metrics = [
    {
      title: "Vendas Totais",
      value: formatCurrency(data?.totalSales || 0),
      icon: "DollarSign",
      color: "text-green-600",
      bgColor: "bg-green-100 dark:bg-green-950",
    },
    {
      title: "Total de Pedidos",
      value: data?.totalOrders || 0,
      icon: "ShoppingCart",
      color: "text-blue-600",
      bgColor: "bg-blue-100 dark:bg-blue-950",
    },
    {
      title: "Ticket Médio",
      value: formatCurrency(data?.averageTicket || 0),
      icon: "TrendingUp",
      color: "text-purple-600",
      bgColor: "bg-purple-100 dark:bg-purple-950",
    },
    {
      title: "Produto Mais Vendido",
      value: data?.topProduct || "N/A",
      icon: "Award",
      color: "text-amber-600",
      bgColor: "bg-amber-100 dark:bg-amber-950",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <Card key={index} className="hover:shadow-lg transition-shadow">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm text-muted-foreground font-medium mb-1">
                  {metric.title}
                </p>
                <p className="text-2xl font-bold text-foreground">
                  {metric.value}
                </p>
              </div>
              <div className={`p-3 rounded-full ${metric.bgColor}`}>
                <Icon name={metric.icon} size={24} className={metric.color} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ReportMetrics;
